import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import querystring from 'query-string'
import classnames from 'classnames'


@withRouter
class Pagination extends Component {

	constructor(props){
		super(props);

        this.makePages = this.makePages.bind(this);
	}

    makePages() {

		const { totalCount, location, parseListParams } = this.props;
		const PAGE_COUNT = 10;
		const LIST_COUNT = 15;

		let listParams = parseListParams(location.search);
		let currentPage = listParams.page;

		let totalPage = parseInt(totalCount / LIST_COUNT) + Math.ceil(totalCount % LIST_COUNT / LIST_COUNT);
		let startPage = parseInt((currentPage - 1) / PAGE_COUNT) * PAGE_COUNT + 1;
		if (startPage > totalPage) {
			startPage = totalPage
		}
		let endPage = startPage + PAGE_COUNT - 1;
		if (endPage > totalPage) {
			endPage = totalPage
		}

		return {
			parsedQueryString: listParams,
			currentPage: currentPage,
			items: new Array(endPage - startPage + 1).fill(startPage).map((p, i) => p + i),
			hasPrev: startPage > 1,
			hasNext: endPage < totalPage
		}
	}

    render() {

    	const { totalCount } = this.props;

    	if(totalCount === null || parseInt(totalCount) <= 0 ) return null;
		let pages = this.makePages();

		let prev, next;

		let emptyPage = '';

		if (pages.hasPrev) {
			let prevPage = pages.items[0] - 1;
			prev = <Link to={"?" + querystring.stringify(Object.assign({}, pages.parsedQueryString, { page: prevPage }))} className="link_paging on">
				<span className="ico_blog ico_prev">이전 페이지</span>
			</Link>
		} else {
			prev = <a className="link_paging"><span className="ico_blog ico_prev">이전 페이지 없음</span></a>
		}

		if (pages.hasNext) {
			let nextPage = pages.items[pages.items.length - 1] + 1
			next = <Link to={"?" + querystring.stringify(Object.assign({}, pages.parsedQueryString, { page: nextPage }))} className="link_paging on">
				<span className="ico_blog ico_next">다음 페이지</span>
			</Link>
		} else {
			next = <a className="link_paging"><span className="ico_blog ico_next">다음 페이지 없음</span></a>
		}

		// items 가 비었을 때 1페이지로 고정.
		if(pages.items.length === 0){
			emptyPage = <li className="on">
					<Link to={"?" + querystring.stringify(Object.assign({}, pages.parsedQueryString, { page: 1 }))} className="link_num">1</Link>
				</li>
		}

        return (
            <div className="wrap_paging">
                <strong className="screen_out">현재 1페이지</strong>
				{ prev }
                <ul className="list_paging">
					{pages.items.map(page =>
						<li key={page} className={classnames({"on": page === pages.currentPage})}>
							<Link to={"?" + querystring.stringify(Object.assign({}, pages.parsedQueryString, { page: page }))} className="link_num">{page}</Link>
						</li>
					)}
                    {emptyPage}
                </ul>
				{ next }
            </div>
        );
    }
}


export default Pagination
